var _path, _path2, _path3, _polygon, _path4, _polygon2, _polygon3, _polygon4, _path5, _polygon5, _polygon6, _polygon7, _path6, _rect, _polygon8, _path7, _rect2, _polygon9, _path8, _polygon10, _path9, _polygon11, _polygon12, _path10, _path11, _path12, _polygon13, _polygon14, _polygon15, _path13, _polygon16, _path14, _polygon17, _polygon18, _polygon19, _path15, _polygon20, _path16, _path17, _path18, _path19, _polygon21, _polygon22, _path20, _path21, _polygon23, _polygon24, _rect3, _path22, _rect4, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPv0HendikepovaniWebLoga512X512PxSvazNeslysicich(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.91,87.83h-205.83c-20.85,0-37.8,16.96-37.8,37.8v260.73c0,20.85,16.96,37.8,37.8,37.8h205.83c20.85,0,37.8-16.96,37.8-37.8V125.63c0-20.85-16.96-37.8-37.8-37.8ZM391.4,386.37c0,17.92-14.58,32.49-32.49,32.49h-205.83c-17.92,0-32.49-14.57-32.49-32.49V125.63c0-17.91,14.57-32.49,32.49-32.49h205.83c17.91,0,32.49,14.58,32.49,32.49v260.73Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.89,310.9h142.22c6.57,0,11.91-5.35,11.91-11.91v-142.21c0-6.57-5.35-11.91-11.91-11.91h-142.22c-6.56,0-11.91,5.35-11.91,11.91v142.21c0,6.57,5.35,11.91,11.91,11.91ZM177.41,156.77c0-4.13,3.36-7.48,7.48-7.48h142.22c4.13,0,7.48,3.36,7.48,7.48v142.21c0,4.13-3.36,7.48-7.48,7.48h-142.22c-4.12,0-7.48-3.36-7.48-7.48v-142.21Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.3,348.43c0-4.56-6.12-4.32-6.12-7.08,0-1,.59-1.55,1.57-1.55,1.23,0,1.41,1.11,1.41,2.19h2.95c.2-3.04-1.27-4.36-4.22-4.36-3.7,0-4.79,1.81-4.79,4.08,0,4.32,6.11,4.49,6.11,7.1,0,.99-.5,1.65-1.52,1.65-1.67,0-1.73-1.17-1.73-2.55h-3.04c-.16,2.51.54,4.73,4.31,4.73,2.31,0,5.07-.44,5.07-4.21Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "195.29 337.88 192.75 348.43 192.71 348.43 190.46 337.88 187.31 337.88 190.89 352.39 194.44 352.39 198.28 337.88 195.29 337.88",
    fill: "#fff",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.51,352.39l-3.94-14.52h-4l-4.02,14.52h2.99l.82-3.21h4.14l.8,3.21h3.2ZM202.97,346.95l1.39-6.27h.04l1.47,6.27h-2.9Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.11 352.39 220.28 352.39 220.28 350.16 214.03 350.16 220.14 340.52 220.14 337.88 211.39 337.88 211.39 340.11 217.2 340.11 211.11 349.74 211.11 352.39",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.31 337.88 234.48 337.88 234.48 347.93 234.43 347.93 230.58 337.88 226.47 337.88 226.47 352.39 229.31 352.39 229.31 341.78 229.35 341.78 233.31 352.39 237.31 352.39 237.31 337.88",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "247.78 340.11 247.78 337.88 239.86 337.88 239.86 352.39 247.95 352.39 247.95 350.16 242.9 350.16 242.9 345.92 247.4 345.92 247.4 343.69 242.9 343.69 242.9 340.11 247.78 340.11",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.32,350.46c-1.66,0-1.73-1.17-1.73-2.55h-3.03c-.16,2.51.54,4.73,4.3,4.73,2.31,0,5.07-.44,5.07-4.21,0-4.56-6.12-4.32-6.12-7.08,0-1,.59-1.55,1.57-1.55,1.23,0,1.41,1.11,1.41,2.19h2.95c.2-3.04-1.26-4.36-4.22-4.36-3.7,0-4.79,1.81-4.79,4.08,0,4.32,6.12,4.49,6.12,7.1,0,.99-.5,1.65-1.53,1.65Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.11 337.88 261.11 352.39 268.7 352.39 268.7 349.99 264.15 349.99 264.15 337.88 261.11 337.88",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.73 352.39 275.73 347.37 279.8 337.88 276.7 337.88 274.38 344.01 272.21 337.88 268.89 337.88 272.7 347.37 272.7 352.39 275.73 352.39",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "287.27 337.16 289.3 334.97 287.03 334.97 285.63 336.15 284.2 334.97 281.92 334.97 283.96 337.16 287.27 337.16",
    fill: "#fff",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.61,350.46c-1.67,0-1.73-1.17-1.73-2.55h-3.03c-.16,2.51.54,4.73,4.3,4.73,2.32,0,5.07-.44,5.07-4.21,0-4.56-6.11-4.32-6.11-7.08,0-1,.58-1.55,1.57-1.55,1.23,0,1.41,1.11,1.41,2.19h2.96c.2-3.04-1.27-4.36-4.23-4.36-3.7,0-4.78,1.81-4.78,4.08,0,4.32,6.11,4.49,6.11,7.1,0,.99-.5,1.65-1.53,1.65Z",
    fill: "#fff",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 292.38,
    y: 337.88,
    width: 3.03,
    height: 14.52,
    fill: "#fff",
    strokeWidth: 0
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.93 334.97 292.12 337.16 294.19 337.16 297.01 334.97 293.93 334.97",
    fill: "#fff",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.84,350.46c-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33c.91,0,1.25.73,1.25,2.66h2.97c.12-3.12-1.13-4.83-4.22-4.83-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5c2.84,0,4.38-1.25,4.38-5.13h-3c-.04,1.15.02,2.95-1.38,2.95Z",
    fill: "#fff",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 309.15,
    y: 337.88,
    width: 3.03,
    height: 14.52,
    fill: "#fff",
    strokeWidth: 0
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "310.7 334.97 308.89 337.16 310.96 337.16 313.77 334.97 310.7 334.97",
    fill: "#fff",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M319.61,350.46c-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33c.9,0,1.24.73,1.24,2.66h2.98c.12-3.12-1.13-4.83-4.22-4.83-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5c2.83,0,4.38-1.25,4.38-5.13h-2.99c-.04,1.15.02,2.95-1.38,2.95Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.53 343.69 329.06 343.69 329.06 337.88 326.02 337.88 326.02 352.39 329.06 352.39 329.06 345.92 332.53 345.92 332.53 352.39 335.57 352.39 335.57 337.88 332.53 337.88 332.53 343.69",
    fill: "#fff",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.6,362.01l-4.02,14.52h3l.82-3.22h4.14l.8,3.22h3.2l-3.94-14.52h-4ZM146,371.08l1.39-6.28h.04l1.47,6.28h-2.9Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.45 372.06 167.41 372.06 163.55 362.01 159.45 362.01 159.45 376.52 162.29 376.52 162.29 365.91 162.33 365.91 166.29 376.52 170.29 376.52 170.29 362.01 167.45 362.01 167.45 372.06",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.88 370.05 180.38 370.05 180.38 367.82 175.88 367.82 175.88 364.24 180.76 364.24 180.76 362.01 172.84 362.01 172.84 376.52 180.92 376.52 180.92 374.29 175.88 374.29 175.88 370.05",
    fill: "#fff",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.02,362.01h-5.07v14.52h4.95c5.18,0,4.84-5.11,4.84-7.34,0-4.53-.74-7.18-4.73-7.18ZM187.46,374.29h-1.47v-10.06h1.57c2.11,0,2.11,2.36,2.11,5.03,0,3.64-.36,5.03-2.21,5.03Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05,361.77c-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5,5.01-3.7,5.01-7.5,0-7.5-5.01-7.5ZM200.05,374.59c-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33,1.93,1.61,1.93,5.33-.22,5.33-1.93,5.33Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.36,365.48c0-1.01.58-1.55,1.56-1.55,1.23,0,1.41,1.1,1.41,2.19h2.95c.2-3.04-1.26-4.36-4.22-4.36-3.7,0-4.79,1.81-4.79,4.08,0,4.32,6.12,4.49,6.12,7.1,0,.98-.5,1.65-1.53,1.65-1.67,0-1.73-1.17-1.73-2.55h-3.03c-.16,2.51.54,4.72,4.3,4.72,2.31,0,5.07-.44,5.07-4.21,0-4.56-6.11-4.32-6.11-7.08Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.24 374.11 221.7 374.11 221.7 362.01 218.66 362.01 218.66 376.52 226.24 376.52 226.24 374.11",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.28 361.28 232.35 361.28 235.17 359.09 232.09 359.09 230.28 361.28",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.25 362.01 231.93 368.14 229.76 362.01 226.44 362.01 230.24 371.5 230.24 376.52 233.28 376.52 233.28 371.5 237.34 362.01 234.25 362.01",
    fill: "#fff",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M248,371.64h-3c-.04,1.15.02,2.96-1.38,2.96-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33c.9,0,1.25.72,1.25,2.66h2.97c.12-3.12-1.13-4.83-4.22-4.83-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5c2.84,0,4.38-1.25,4.38-5.13Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.54 367.82 253.06 367.82 253.06 362.01 250.03 362.01 250.03 376.52 253.06 376.52 253.06 370.05 256.54 370.05 256.54 376.52 259.58 376.52 259.58 362.01 256.54 362.01 256.54 367.82",
    fill: "#fff",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.07,373.31l.8,3.22h3.2l-3.94-14.52h-4l-4.02,14.52h2.99l.83-3.22h4.14ZM266.91,364.8h.04l1.47,6.28h-2.9l1.38-6.28Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.31 362.01 278.78 372.56 278.74 372.56 276.49 362.01 273.33 362.01 276.91 376.52 280.47 376.52 284.31 362.01 281.31 362.01",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.27 359.09 290.2 359.09 288.39 361.28 290.46 361.28 293.27 359.09",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.03 368.14 287.87 362.01 284.55 362.01 288.35 371.5 288.35 376.52 291.38 376.52 291.38 371.5 295.45 362.01 292.35 362.01 290.03 368.14",
    fill: "#fff",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.72,374.59c-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33c.9,0,1.25.72,1.25,2.66h2.97c.12-3.12-1.13-4.83-4.22-4.83-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5c2.84,0,4.38-1.25,4.38-5.13h-2.99c-.04,1.15.02,2.96-1.39,2.96Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.65 367.82 311.17 367.82 311.17 362.01 308.14 362.01 308.14 376.52 311.17 376.52 311.17 370.05 314.65 370.05 314.65 376.52 317.68 376.52 317.68 362.01 314.65 362.01 314.65 367.82",
    fill: "#fff",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329.65,361.77c-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5,5.01-3.7,5.01-7.5,0-7.5-5.01-7.5ZM329.65,374.59c-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33,1.93,1.61,1.93,5.33-.22,5.33-1.93,5.33Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M339.96,365.48c0-1.01.58-1.55,1.56-1.55,1.23,0,1.41,1.1,1.41,2.19h2.96c.2-3.04-1.27-4.36-4.23-4.36-3.7,0-4.78,1.81-4.78,4.08,0,4.32,6.11,4.49,6.11,7.1,0,.98-.5,1.65-1.53,1.65-1.67,0-1.73-1.17-1.73-2.55h-3.03c-.16,2.51.54,4.72,4.3,4.72,2.31,0,5.07-.44,5.07-4.21,0-4.56-6.11-4.32-6.11-7.08Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M353.11,361.77c-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5,5.01-3.7,5.01-7.5,0-7.5-5.01-7.5ZM353.11,374.59c-1.71,0-1.93-1.61-1.93-5.33s.22-5.33,1.93-5.33,1.93,1.61,1.93,5.33-.22,5.33-1.93,5.33Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M367.71,369v-.04c1.65-.32,2.47-1.53,2.47-3.2,0-3.1-1.91-3.76-4.23-3.76h-5.39v14.52h5.37c1.29,0,4.49-.16,4.49-3.84,0-1.99-.57-3.38-2.71-3.68ZM363.6,364.24h1.87c1.02,0,1.75.78,1.75,1.85,0,1.41-.93,1.85-1.59,1.85h-2.03v-3.7ZM365.29,374.29h-1.69v-4.12h1.77c1.53,0,2.01.78,2.01,2.07,0,2.03-1.45,2.05-2.09,2.05Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.58 398.12 223.54 398.12 222.11 390.5 219.24 390.5 221.93 400.65 225.05 400.65 227.84 390.5 225.07 390.5 223.58 398.12",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.86 383.22 236.89 385.41 240.2 385.41 242.24 383.22 239.96 383.22 238.56 384.41 237.13 383.22 234.86 383.22",
    fill: "#fff",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.6,398.72c-1.71,0-1.93-1.6-1.93-5.33s.22-5.33,1.93-5.33c.9,0,1.24.72,1.24,2.65h2.98c.12-3.12-1.13-4.83-4.22-4.83-5.01,0-5.01,3.66-5.01,7.5s0,7.5,5.01,7.5c2.83,0,4.38-1.24,4.38-5.13h-3c-.04,1.15.02,2.95-1.38,2.95Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M251.17,393.53v-.04c1.97-.32,2.69-1.71,2.69-3.56,0-2.47-1.33-3.8-3.4-3.8h-5.61v14.52h3.03v-6.01h.78c2.33,0,2.17,1.47,2.17,3.2,0,.95-.08,1.93.32,2.82h2.97c-.28-.61-.34-3.34-.34-4.26,0-2.62-1.97-2.77-2.63-2.86ZM249.23,392.41h-1.34v-4.04h1.34c.97,0,1.55.52,1.55,1.91,0,.93-.34,2.13-1.55,2.13Z",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.33 402.6 257.26 402.6 258.78 397.99 256.15 397.99 255.33 402.6",
    fill: "#fff",
    strokeWidth: 0
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.05 392.51 271.05 390.5 264.35 390.5 264.35 392.31 268.19 392.31 264.21 398.64 264.21 400.65 271.11 400.65 271.11 398.84 267.01 398.84 271.05 392.51",
    fill: "#fff",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 272.6,
    y: 397.99,
    width: 2.41,
    height: 2.66,
    fill: "#fff",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M283.85,392.97c0-.68.34-1.08.97-1.08.3,0,.54.04.72.22.2.18.28.6.28,1.3h2.77c.16-2.19-1.59-3.12-3.52-3.12s-4,.67-4,2.86c0,3.24,4.98,2.75,4.98,4.9,0,.69-.48,1.05-1.04,1.05s-.87-.16-1.03-.48c-.14-.32-.16-.76-.14-1.23h-2.77c-.16,2.84,1.49,3.46,3.96,3.46s3.8-1.32,3.8-3.1c0-3.25-4.98-3.18-4.98-4.79Z",
    fill: "#fff",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 290.45,
    y: 397.99,
    width: 2.41,
    height: 2.66,
    fill: "#fff",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.48,218.19c.28,4.85-1.35,9.52-4.6,13.15l-.59.66,5.49,4.88.59-.66c4.54-5.09,6.82-11.64,6.43-18.44-.8-14.06-12.89-24.85-26.95-24.05-9.53.54-17.9,6.29-21.83,15l-.36.81,6.69,3.02.37-.8c2.8-6.22,8.76-10.32,15.55-10.7,10.02-.57,18.64,7.12,19.21,17.14Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M279.61,185.93l-.19-.12c-7.18-5.05-16.71-7.63-26.13-7.09-3.31.19-6.48.77-9.4,1.72-18.66,6.05-27.72,25.43-28.1,26.26l-.37.81,6.68,3.03.37-.8c.08-.17,8.24-17.34,23.72-22.34,2.23-.72,4.67-1.16,7.26-1.3,7.78-.44,16.04,1.78,22.1,5.95,20.9,14.44,13.52,33.84,7.26,44.12-2.43,4-6.23,6.42-9.67,8.6-2.24,1.43-4.34,2.77-5.87,4.49-1.5,1.69-2.49,4.25-3.74,7.48-2.02,5.22-4.54,11.71-8.81,12.66-.78.17-1.54.28-2.28.32-5.18.3-7.74-2.74-7.76-2.77l-.56-.69-5.71,4.61.56.69c.5.62,5.13,6,13.86,5.5,1.13-.06,2.3-.23,3.47-.49,8.11-1.8,11.55-10.68,14.07-17.17.74-1.92,1.76-4.55,2.38-5.26.86-.96,2.48-2,4.51-3.29,3.8-2.42,8.52-5.44,11.82-10.87,4.8-7.86,18.28-34.98-9.46-54.05Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M326.06,157.82h-140.13v140.12h140.13v-140.12ZM321.63,293.51h-112.82l36.78-36.78-20.88-20.88-34.34,34.35v-107.96h107.95l-15.09,15.09,20.88,20.88,17.53-17.53v112.82Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPv0HendikepovaniWebLoga512X512PxSvazNeslysicich);
export default __webpack_public_path__ + "static/media/PV0-Hendikepovani-web-loga-512x512px-svaz-neslysicich.cf86bd1b75027f5843d209863ec4e017.svg";
export { ForwardRef as ReactComponent };